// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import routes from './routes'
import VueRouter from 'vue-router'
import VueSweetAlert from 'vue-sweetalert'
import 'element-ui/lib/theme-default/index.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import store from './store'
import VueResize from 'vue-resize'

Vue.use(VueResize)
Vue.use(VueRouter)
Vue.use(VueSweetAlert)
Vue.use(ElementUI, { locale })

const router = new VueRouter({
	routes
})

require('./assets/css/font-awesome/css/font-awesome.min.css')
require('./assets/css/simple-line-icons/simple-line-icons.min.css')
require('./assets/css/bootstrap/css/bootstrap.min.css')
require('./assets/css/cubeportfolio/css/cubeportfolio.min.css')
require('./assets/css/components-md.min.css')
require('./assets/css/login.min.css')
require('./assets/css/search.min.css')
require('./assets/css/blog.min.css')
require('./assets/css/layout/css/custom.css')
require('./assets/css/layout/css/layout.min.css')
require('./assets/css/layout/css/themes/unoapp.css')
require('./assets/css/jstree/style.min.css')

let App = new Vue({
	router,
	store,
	methods: {
		/**
		 * A wrapper to handle errors for special cases
		 * @param {function} errorCallback - A function to be run if all of the special error cases are passed
		 * @returns {function} - A function that determines if it needs to apply special logic or just run the callback
		 * @version 0.0.9
		 */
		errorWrapper (errorCallback) {
			return e => {
				if (e.responseJSON && e.responseJSON.declaration) {
					switch (e.responseJSON.declaration) {
					case 'auth_token_needs_refresh':
						return

					case 'no_account_selected':
						if (this.$store.getters.userAccountsLength) {
							// Redirect to the account selection page to allow the user to select an account
							this.$router.replace('/app/select_account')
							return
						}
						break

					case 'csrf_token_mismatch':
					case 'auth_token_missing':
					case 'auth_token_expired':
					case 'auth_token_invalid':
						// Redirect to the login screen and clear all variables
						/* eslint-disable no-undef */
						localStorage.removeItem('sessionStart')
						this.$router.push('/login')
						return

					default:
						// No default
					}
				}

				errorCallback(e)
			}
		}
	}
})

App.$mount('#app')

export {App}



// WEBPACK FOOTER //
// ./src/main.js